import type { DataGrid } from '../types'

export function registerRowDom(
  internalData: GridInternalData,
  rowId: string,
  el: HTMLElement
) {
  let set = internalData.rowDomMaps?.[rowId]
  if (!internalData.rowDomMaps) {
    internalData.rowDomMaps = {}
  }
  if (!set) {
    set = new Set()
    internalData.rowDomMaps[rowId] = set
  }
  set.add(el)
}

export function unregisterRowDom(
  internalData: GridInternalData,
  rowId: string,
  el: HTMLElement
) {
  const set = internalData.rowDomMaps[rowId]
  if (!set) {
    return
  }
  set.delete(el)
  if (!set.size) {
    delete internalData.rowDomMaps[rowId]
  }
}

export function forEachRowDom(
  internalData: GridInternalData,
  rowId: string,
  fn: (el: HTMLElement) => void
) {
  const set = internalData.rowDomMaps[rowId]
  if (!set) {
    return false
  }
  set.forEach(fn)
  return true
}

/** 遍历同一行的全部 DOM 副本（主区 + 左/右固定列） */
export function forEachRowEl(
  $grid: DataGrid,
  rowId: string,
  fn: (el: HTMLElement) => void
) {
  const seen = new Set<HTMLElement>()
  forEachRowDom($grid.internalData, rowId, (el) => {
    if (!seen.has(el)) {
      seen.add(el)
      fn(el)
    }
  })
  const root = $grid.bodyRef?.value
  if (!root) {
    return
  }
  root.querySelectorAll(`[data-row-id="${rowId}"]`).forEach((el) => {
    const node = el as HTMLElement
    if (!seen.has(node)) {
      seen.add(node)
      fn(node)
    }
  })
}
